var map = {
	"./block_1.png": "332a",
	"./block_1_tape.png": "2ae7",
	"./block_2.png": "9d7e",
	"./block_2_green_pin.png": "116e",
	"./block_2_img.png": "cdff",
	"./block_3.png": "e77d",
	"./block_3_binder.png": "8e86",
	"./block_3_img.png": "fafe",
	"./block_4.png": "6a76",
	"./block_4_img.png": "1ccd",
	"./block_4l_ove_NY.png": "bbb2",
	"./block_5_circle.png": "d12a",
	"./block_6_red_pin.png": "cf5a",
	"./block_7_green_pin.png": "b725",
	"./icn_close.svg": "8108",
	"./img_block_1.png": "18bf",
	"./img_thank_you.png": "b564",
	"./line_1.png": "63e3",
	"./line_2.png": "3246",
	"./line_3.png": "bb67",
	"./logo.svg": "9b19",
	"./logo_1.png": "93d3",
	"./logo_2.png": "3297",
	"./logo_3.png": "e0a6",
	"./logo_4.png": "44d8",
	"./logo_5.png": "9384",
	"./main block illustration.png": "a59b",
	"./preload.gif": "8682"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";